import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const LeftNavOpenIcon: React.FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path d="M26 6v20H13V6h13ZM6 6h5v20H6V6Zm0-2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm12.207 16.707 3.647-3.646a1.5 1.5 0 0 0 0-2.122l-3.647-3.646a1 1 0 0 0-1.414 1.414L20.086 16l-3.293 3.293a1 1 0 0 0 1.414 1.414Z" />
    </BaseIcon>
  );
};
